import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './client/App';
import { isNative } from './client/lib/platform';

// In the app, turn off pinch zoom and the iOS zoom-in when a form field is tapped.
// The website keeps zoom for accessibility.
if (isNative) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
